import { X, CheckCircle2, Info, AlertTriangle } from 'lucide-react';
import { useToastStore } from '@/stores/toastStore';
import { useLanguage } from '@/hooks/useLanguage';

const iconMap = {
  success: (
    <CheckCircle2 className="h-6 w-6 text-emerald-400" />
  ),
  error: (
    <AlertTriangle className="h-6 w-6 text-red-400" />
  ),
  info: (
    <Info className="h-6 w-6 text-brand-orange-base" />
  ),
};

const backgroundMap = {
  success: 'from-emerald-500/90 to-emerald-600/90 border-emerald-300/40',
  error: 'from-red-500/90 to-red-600/90 border-red-300/40',
  info: 'from-brand-purple-base/90 to-brand-orange-base/90 border-white/20',
};

const Toast = () => {
  const { message, type, isVisible, hideToast } = useToastStore();
  const { isRTL } = useLanguage();

  if (!message) return null;

  return (
    <div
      className={`fixed bottom-6 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      } ${isRTL ? 'left-6' : 'right-6'}`}
      aria-live="assertive"
      aria-atomic="true"
    >
      <div
        className={`flex items-start gap-4 px-5 py-4 rounded-2xl shadow-2xl backdrop-blur-md border ${backgroundMap[type]} text-white min-w-[260px] max-w-sm`}
      >
        <div className="mt-0.5">{iconMap[type]}</div>
        <div className="flex-1 text-sm leading-relaxed">{message}</div>
        <button
          type="button"
          onClick={hideToast}
          className="text-white/80 hover:text-white transition-colors"
          aria-label="Close notification"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Toast;


